<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                    :btn-title="$t('pipelines.label.prospect')"
                    :options="contacts"
                    value-field="id"
                    name-field="fullname"
                    v-model="query.contact_id"
                    :border="true"
                />
          </div>   
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="getAveragePaymentDelay == 0" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div class="p-5">
              <canvas id="kt_chartjs_payments" class="mh-200px"></canvas> 
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import {  shallowRef,onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { useLocales } from '@/composables/locales';
import Loader from '@/components/Loader.vue';

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    contact_id: '',
    payment_type_id: ""
})

const getAveragePaymentDelay = ref(0)
const chartPaymentRef = shallowRef(null)

const contacts = computed(() => store.getters['contacts/getContacts'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
       props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, contact_id: query.value.contact_id, payment_type_id: query.value.payment_type_id}).then((res) => {
         getAveragePaymentDelay.value = res?.data?.getAveragePaymentDelay || res?.response?.data;

        }),  
        store.dispatch('contacts/loadContacts'),

    ]).then(() => {
      chartPayment()
    }) 
  }
    
}

function chartPayment() {
  const ctx = document.getElementById('kt_chartjs_payments').getContext('2d');
  if(ctx){
    if(Chart.getChart("kt_chartjs_payments")) {
      Chart.getChart("kt_chartjs_payments")?.destroy()
    }
  }

  let colors = ['rgba(45, 163, 51, 1)', 'rgba(243, 220, 31, 1)', 'rgba(240, 120, 23, 1)', 'rgba(229, 19, 53, 1)'];
  let number = getAveragePaymentDelay.value ? getAveragePaymentDelay.value[locale.value]?.split(' ')[0] : 0
  const gradient = ctx.createLinearGradient(0, 0, ctx.canvas.width, 0);
  gradient.addColorStop(0, 'rgba(45, 163, 51, 1)');
  gradient.addColorStop(0.33, 'rgba(243, 220, 31, 1)');
  gradient.addColorStop(0.66, 'rgba(240, 120, 23, 1)');
  gradient.addColorStop(1, 'rgba(229, 19, 53, 1)');

  let intervals = [3, 6, 9, 12];
  let colorIndex = 0;
  for (let i = 0; i < intervals.length; i++) {
    if (number <= intervals[i]) {
      colorIndex = i;
      break;
    }
  }

  let data = {
    labels: ['0-3', '3-6', '6-9', '9-12'],
    datasets: [{
      data: [25, 25, 25, 25],
      backgroundColor: gradient,
      hoverOffset: 10,
      borderColor: 'transparent'
    }]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
    },
    cutout: '70%',
    rotation: -90,
    circumference: 180
  };

  let config = {
    type: 'doughnut',
    data: data,
    options: options,
    plugins: [{
      afterDraw: function(chart) {
        let width = chart.width,
          height = chart.height,
          ctx = chart.ctx;

        ctx.restore();
        let fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        let text = `${getAveragePaymentDelay.value ? getAveragePaymentDelay.value[locale.value] : ''}`,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 1.30;

        ctx.fillStyle = colors[colorIndex];
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    }]
  };

  if (!chartPaymentRef.value) {
    chartPaymentRef.value = new Chart(ctx, config);
  } else {
    chartPaymentRef.value.destroy();
    chartPaymentRef.value = new Chart(ctx, config);
  }
}
  
onMounted(() => {
   if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>